import { render, staticRenderFns } from "./index.vue?vue&type=template&id=abfd4a1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfd4a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abfd4a1c')) {
      api.createRecord('abfd4a1c', component.options)
    } else {
      api.reload('abfd4a1c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=abfd4a1c&scoped=true", function () {
      api.rerender('abfd4a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/protocolCompliance/protocolManage/index.vue"
export default component.exports